{
  "accountHealth": "账户健康度",
  "activeCopies": "当前跟单",
  "addFavorite": "添加收藏",
  "affectedCoins": "受影响币种",
  "aiAlert": "AI 提醒",
  "aiArbitrageScanner": "AI 套利扫描器",
  "aiCenter": "AI 中心",
  "aiConfidence": "AI 置信度",
  "aiConfidenceMeter": "AI 置信度仪表",
  "aiCopyTrading": "AI 跟单交易",
  "aiFinalDecision": "AI 最终决策",
  "aiGridTrading": "AI 网格交易",
  "aiLaunchpad": "AI Launchpad",
  "aiMarketNews": "AI 市场资讯",
  "aiMarketScanner": "AI 市场扫描器",
  "aiNews": "AI 资讯",
  "aiPortfolioManager": "AI 资产组合管理",
  "aiProfitCalculator": "AI 收益计算器",
  "aiRankedTrader": "AI 排名交易者",
  "aiRebalance": "AI 再平衡",
  "aiRecommendation": "AI 推荐",
  "aiRecommendations": "AI 建议",
  "aiResult": "AI 结果",
  "aiRiskEngine": "AI 风险引擎",
  "aiRiskLevel": "AI 风险等级",
  "aiRiskManager": "AI 风险管理",
  "aiScanResult": "AI 扫描结果",
  "aiScore": "AI 评分",
  "aiSignal": "AI 信号",
  "aiSmartAlerts": "AI 智能提醒",
  "aiSubtitle": "AI 驱动的交易、分析、自动化及风险管理。",
  "aiSuggestions": "AI 建议",
  "aiTitle": "人工智能",
  "aiTrader": "AI 交易者",
  "aiTradingAssistant": "AI 交易助手",
  "aiTradingAssistantSubtitle": "实时 AI 市场信号、情绪及趋势分析。",
  "aiTrustScore": "AI 信任评分",
  "aiWhaleAlerts": "AI 巨鲸预警",
  "aiWhaleHeatmap": "AI 巨鲸热力图",
  "aiWhaleTracker": "AI 巨鲸追踪",
  "alertType": "提醒类型",
  "allCategories": "所有分类",
  "allImpact": "所有影响",
  "allImpacts": "所有影响",
  "allSentiments": "所有情绪",
  "allSymbols": "所有代号",
  "apply": "应用",
  "applySafeModeScan": "应用安全模式扫描",
  "applying": "应用中...",
  "arbitrageOpportunities": "套利机会",
  "assetAllocation": "资产配置",
  "audit": "审计",
  "backendPreviewAlerts": "提醒在保存前会在此处预览。",
  "backendWillSaveAfterApi": "后台确认请求后将保存此内容。",
  "baseCoin": "基础币种",
  "breaking": "突发",
  "btcDominance": "BTC 市值占比",
  "btcVolatilityNews": "BTC 波动性资讯",
  "buyDecision": "买入",
  "buyExchange": "买入交易所",
  "buyPressure": "买盘压力",
  "buyPrice": "买入价格",
  "buySignal": "买入",
  "buyStrength": "买盘强度",
  "buyVolume": "买入量",
  "buyZone": "买入区间",
  "calculate": "计算",
  "calculateAiProfit": "计算 AI 收益",
  "calculating": "计算中...",
  "capitalGreaterThanZero": "本金必须大于零。",
  "capitalProtection": "资金保护",
  "category": "分类",
  "clear": "清除",
  "communityScore": "社区评分",
  "compoundDays": "复利天数",
  "compoundResult": "复利结果",
  "condition": "条件",
  "confidence": "置信度",
  "confidenceScore": "置信度评分",
  "contractSafety": "合约安全性",
  "copyTradeIdMissing": "跟单交易 ID 缺失。",
  "copyTrader": "跟单交易者",
  "copyTradingStarted": "跟单交易已开始。",
  "copyTradingStopped": "跟单交易已停止。",
  "createAiAlert": "创建 AI 提醒",
  "createAiOpportunity": "创建 AI 机会",
  "createAiWhaleAlert": "创建 AI 巨鲸提醒",
  "createGridStrategy": "创建网格策略",
  "createLaunchpadProject": "创建 Launchpad 项目",
  "createOpportunity": "创建机会",
  "createSmartAlert": "创建智能提醒",
  "createWhaleAlert": "创建巨鲸提醒",
  "created": "已创建",
  "creating": "创建中...",
  "currentPrice": "当前价格",
  "currentRiskScore": "当前风险评分",
  "dailyProfit": "每日收益",
  "delete": "删除",
  "deleteCalculationConfirm": "确定要删除此计算吗？",
  "deleteMarketScanConfirm": "确定要删除此市场扫描吗？",
  "detected": "已检测到",
  "diversification": "多元化",
  "emailAlert": "邮件提醒",
  "enableCompoundingProjection": "启用复利预测",
  "enterCopyAmountFor": "输入跟单金额，用于",
  "enterNewsTitle": "输入资讯标题",
  "exitPrice": "出场价格",
  "expectedLoss": "预期亏损",
  "expectedProfit": "预期收益",
  "extremeFear": "极度恐惧",
  "extremeGreed": "极度贪婪",
  "failedCalculateProfit": "收益计算失败。",
  "failedCreateArbitrageOpportunity": "套利机会创建失败。",
  "failedCreateGridStrategy": "网格策略创建失败。",
  "failedCreateLaunchpadProject": "Launchpad 项目创建失败。",
  "failedCreateSmartAlert": "智能提醒创建失败。",
  "failedDeleteCalculation": "计算删除失败。",
  "failedDeleteMarketScan": "市场扫描删除失败。",
  "failedLoadAiNews": "AI 资讯加载失败。",
  "failedLoadArbitrageScanner": "套利扫描器加载失败。",
  "failedLoadGridTrading": "网格交易加载失败。",
  "failedLoadLaunchpad": "Launchpad 加载失败。",
  "failedLoadMarketScanner": "市场扫描器加载失败。",
  "failedLoadProfitCalculator": "收益计算器加载失败。",
  "failedLoadRiskManager": "风险管理器加载失败。",
  "failedLoadSmartAlerts": "智能提醒加载失败。",
  "failedLoadTrustScore": "信任评分加载失败。",
  "failedLoadWhaleHeatmap": "巨鲸热力图加载失败。",
  "failedLoadWhaleTracker": "巨鲸追踪器加载失败。",
  "failedLogins": "登录失败次数",
  "failedMarkAlertRead": "标记提醒为已读失败。",
  "failedNewsAction": "此操作未能完成。",
  "failedRefreshRiskProfile": "风险档案刷新失败。",
  "failedRunMarketScan": "市场扫描运行失败。",
  "failedStartCopyTrading": "跟单交易启动失败。",
  "failedStopCopyTrading": "跟单交易停止失败。",
  "failedSubmitNews": "资讯提交失败。",
  "failedSyncSymbol": "代号同步失败。",
  "failedToLoadData": "AI 数据加载失败。",
  "failedUpdateFavorite": "收藏更新失败。",
  "favorite": "收藏",
  "fear": "恐惧",
  "fearGreedGauge": "恐惧与贪婪指数表",
  "fearGreedIndex": "恐惧与贪婪指数",
  "featuredLaunch": "精选发行",
  "generate": "生成",
  "generateAiGrid": "生成 AI 网格",
  "generating": "生成中...",
  "greed": "贪婪",
  "gridCount": "网格数量",
  "gridStrategies": "网格策略",
  "grids": "网格",
  "hardCap": "硬顶",
  "heat": "热度",
  "high": "高",
  "highPriority": "高优先级",
  "highRisk": "高风险",
  "highRiskDetected": "检测到高风险。",
  "highWithdrawals": "大额提现",
  "holderScore": "持有人评分",
  "impact": "影响",
  "investment": "投资额",
  "kycCompleted": "KYC 已完成",
  "lastScan": "上次扫描",
  "lastUpdated": "最后更新",
  "latestAlert": "最新提醒",
  "launchpadProjects": "Launchpad 项目",
  "liquidityScore": "流动性评分",
  "liveAiMarketSignal": "实时 AI 市场信号",
  "liveVolume": "实时成交量",
  "liveWhaleAlerts": "实时巨鲸提醒",
  "loading": "加载中...",
  "loadingAi": "AI 数据加载中...",
  "loadingAiNews": "AI 资讯加载中...",
  "loadingArbitrageScanner": "套利扫描器加载中...",
  "loadingGridTrading": "网格交易加载中...",
  "loadingLaunchpad": "Launchpad 加载中...",
  "loadingMarketScanner": "市场扫描器加载中...",
  "loadingProfitCalculator": "收益计算器加载中...",
  "loadingRiskManager": "风险管理器加载中...",
  "loadingSmartAlerts": "智能提醒加载中...",
  "loadingTrustScore": "信任评分加载中...",
  "loadingWhaleAlerts": "巨鲸提醒加载中...",
  "loadingWhaleHeatmap": "巨鲸热力图加载中...",
  "loadingWhaleTracker": "巨鲸追踪器加载中...",
  "lowRisk": "低风险",
  "lowRiskDetected": "检测到低风险。",
  "lowerPrice": "下限价格",
  "markRead": "标记为已读",
  "marketSentiment": "市场情绪",
  "marketType": "市场类型",
  "marketWeaknessDetected": "检测到市场疲软。",
  "maxBuy": "最大购买量",
  "medium": "中等",
  "mediumRisk": "中等风险",
  "mediumRiskDetected": "检测到中等风险。",
  "minBuy": "最小购买量",
  "minimumWhaleAmountUsd": "最低巨鲸金额 (USD)",
  "moderateTrend": "温和趋势",
  "monthlyProfit": "月收益",
  "myCopyTrades": "我的跟单交易",
  "myMarketScanHistory": "我的市场扫描历史",
  "myProfitHistory": "我的收益历史",
  "neutralDecision": "中性",
  "neutralMarketConditions": "市场情况中性。",
  "neutralSignal": "中性",
  "newsFeed": "资讯动态",
  "noActiveCopyTrades": "暂无进行中的跟单交易。",
  "noAiNewsFound": "未找到 AI 资讯。",
  "noAlertsFound": "未找到提醒。",
  "noCalculationYet": "尚无计算记录。",
  "noDate": "无日期",
  "noGridStrategiesFound": "未找到网格策略。",
  "noHeatmapDataFound": "未找到热力图数据。",
  "noLaunchpadProjectsFound": "未找到 Launchpad 项目。",
  "noOpportunitiesFound": "未找到机会。",
  "noPinnedNews": "暂无置顶资讯。",
  "noRecommendationYet": "暂无建议。",
  "noRiskHistoryYet": "暂无风险历史。",
  "noSavedCalculations": "暂无已保存的计算。",
  "noSavedScans": "暂无已保存的扫描。",
  "noScanYet": "尚未扫描。",
  "noTrustScoresFound": "未找到信任评分。",
  "noWhaleTransactionsFound": "未找到巨鲸交易。",
  "noWhaleWalletsDetected": "未检测到巨鲸钱包。",
  "notScannedYet": "尚未扫描。",
  "p2pDisputes": "P2P 争议",
  "pinned": "已置顶",
  "pinnedNews": "置顶资讯",
  "portfolioExposure": "投资组合风险敞口",
  "portfolioRebalancedSuccessfully": "资产组合再平衡成功。",
  "position": "仓位",
  "priority": "优先级",
  "processing": "处理中...",
  "projectName": "项目名称",
  "raised": "已筹集",
  "raisedAmount": "已筹集金额",
  "rebalanceFailed": "再平衡失败。",
  "records": "记录",
  "refresh": "刷新",
  "refreshAiScan": "刷新 AI 扫描",
  "risk": "风险",
  "riskFactors": "风险因素",
  "riskHistory": "风险历史",
  "riskLevel": "风险等级",
  "riskReward": "风险/收益比",
  "riskRewardRatio": "风险/收益比",
  "riskScore": "风险评分",
  "roi": "投资回报率",
  "runAiMarketScan": "运行 AI 市场扫描",
  "runAiScan": "运行 AI 扫描",
  "safe": "安全",
  "scan": "扫描",
  "scanning": "扫描中...",
  "searchAiNews": "搜索 AI 资讯...",
  "searchWalletOrSymbol": "搜索钱包或代号...",
  "sellDecision": "卖出",
  "sellExchange": "卖出交易所",
  "sellPressure": "卖盘压力",
  "sellPrice": "卖出价格",
  "sellSignal": "卖出",
  "sellVolume": "卖出量",
  "sellZone": "卖出区间",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "signal": "信号",
  "signalStrength": "信号强度",
  "smartAlerts": "智能提醒",
  "softCap": "软顶",
  "source": "来源",
  "sourceUrl": "来源链接",
  "spread": "价差",
  "stop": "停止",
  "strongBuyDecision": "强烈买入",
  "strongBuyOpportunity": "强烈买入机会。",
  "strongTrend": "强劲趋势",
  "submitAiNews": "提交 AI 资讯",
  "submitNews": "提交资讯",
  "submitNewsForAiAnalysis": "提交资讯以供 AI 分析。",
  "suggestedCopy": "建议跟单金额",
  "suggestedLeverage": "建议杠杆",
  "summary": "摘要",
  "suspiciousActivity": "可疑活动",
  "sync": "同步",
  "syncing": "同步中...",
  "targetPrice": "目标价格",
  "telegramAlert": "Telegram 提醒",
  "timeframe": "时间周期",
  "title": "标题",
  "titleSummaryRequired": "标题和摘要为必填项。",
  "tokenPrice": "代币价格",
  "topGainers": "涨幅榜",
  "topGridStrategy": "顶尖网格策略",
  "topLosers": "跌幅榜",
  "topOpportunity": "顶尖机会",
  "topWhaleWallets": "顶尖巨鲸钱包",
  "totalAlerts": "提醒总数",
  "totalCopied": "跟单总额",
  "totalNews": "资讯总数",
  "totalPL": "总盈亏",
  "totalValue": "总价值",
  "totalWhaleVolume": "巨鲸总成交量",
  "tradeSetup": "交易设置",
  "transferVolume": "转账量",
  "trend": "趋势",
  "trendStrength": "趋势强度",
  "upperPrice": "上限价格",
  "usdValue": "美元价值",
  "viewDetails": "查看详情",
  "volatility": "波动性",
  "volatilityIndex": "波动率指数",
  "weakTrend": "疲弱趋势",
  "whaleAccumulation": "巨鲸吸筹",
  "whaleActivity": "巨鲸动态",
  "whaleAlertCreatedFor": "巨鲸提醒已创建，针对",
  "whaleRisk": "巨鲸风险",
  "whaleScore": "巨鲸评分",
  "writeNewsSummary": "撰写资讯摘要",
  "yearlyProfit": "年收益"
}